"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = void 0;

var _create = require("./create");

var create = {
  newThingUI: _create.newThingUI
};
exports.create = create;
//# sourceMappingURL=index.js.map